<template>
  <div
    class="category"
    :class="{ warning: isCoverFrame && hasCoverFrameWarning }"
    :data-category-id="category.id"
  >
    <div class="inner" @click="selectPopup(category.id)">
      <img class="icon" :src="category.img" />

      <template v-if="isCoverFrame">
        <TweenPrice
          class="amount"
          :price="currentCoverFrameAmount"
          :with-format="false"
        />
        /
        <TweenPrice
          class="amount-required"
          :price="requiredCoverFrameAmount"
          :with-format="false"
        />
      </template>
      <template v-else>
        <TweenPrice
          class="amount"
          :price="categoryAmount"
          :with-format="false"
        />
      </template>

      <span class="footer-cat-name">{{ category.name }}</span>
    </div>

    <portal to="destination">
      <CategoryPopup
        v-if="popupIsSelected"
        :category="category"
        :products="products"
        :style="categoryPopupStyling"
        @closePopup="$emit('closePopup')"
      />
      <div
        v-if="popupIsSelected"
        class="overlay"
        @click="selectPopup(-1)"
      ></div>
    </portal>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import coverFrameMixin from '../../mixins/cover-frame-mixin';
import AppFooterCategoryPopup from './AppFooterCategoryPopup';
import TweenPrice from '../utilities/TweenPrice';

export default {
  name: 'AppFooterCategory',

  mixins: [coverFrameMixin],

  components: {
    TweenPrice,
    CategoryPopup: AppFooterCategoryPopup,
  },

  props: {
    category: {
      required: true,
      type: Object,
    },
    selectedCategoryId: {
      type: Number,
      default: null,
    },
  },

  computed: {
    ...mapState('step', ['currentStep']),
    ...mapGetters('category-products', ['getProductsByCategory']),
    products() {
      return this.getProductsByCategory(this.category.id);
    },
    hasProducts() {
      return this.products.length > 0;
    },
    popupIsSelected() {
      return this.category.id === this.selectedCategoryId;
    },
    categoryPopupStyling() {
      function clamp(num, min, max) {
        return Math.min(Math.max(num, min), max);
      }

      const popupWidth = 300; //would be better if this were calculated but figuring out the race conditions isn't worth the time
      const categoryElement = document.querySelector(
        `[data-category-id="${this.selectedCategoryId}"]`
      );

      //place popup in the horizontal center of the footer item
      const leftValue =
        categoryElement.offsetLeft -
        categoryElement.offsetParent.scrollLeft +
        categoryElement.offsetWidth / 2;

      const maxHeightValue = window.innerHeight - 100;

      return {
        //clamp the leftValue to prevent it from being rendered halfway off screen
        left: `${clamp(
          leftValue,
          popupWidth / 2,
          document.body.clientWidth - popupWidth / 2
        )}px`,
        bottom: `${categoryElement.offsetHeight}px`,
        maxHeight: `${maxHeightValue}px`,
      };
    },
  },

  methods: {
    selectPopup(categoryId) {
      if (categoryId === null) {
        this.$emit('closePopup');
        return;
      }

      if (this.currentStep === 1) {
        if (this.hasProducts) {
          this.$emit('selectPopup', categoryId);
        }
      } else {
        this.$emit('selectPopup', categoryId);
      }
    },
  },
};
</script>
